import Button from "@/common/components/Button";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { formatDateTime } from "@/common/utils/formatters";
import { ArrowBigRightIcon, BriefcaseBusinessIcon, CarFrontIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { maintenanceWorkflowStatus } from "../constants/maintenanceWorkflowsStatus.constant";
import { MaintenaceWorkflowData } from "../types/maintenanceWorkflows.type";
import { maintenanceForwardingsDirectiveEntryKlasses } from "../constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { maintenanceForwardingStatus } from "../constants/forwardings/maintenanceForwardingStatus.constant";

export class MaintenanceWorkflowsTransformer {

  static tableTransformer() {
    return (workflows: MaintenaceWorkflowData[]) => {
      return workflows.map((workflow) => {
        return {
          status: maintenanceWorkflowStatus[workflow.status] || workflow.status,
          current_forwarding: workflow.current_forwarding && (
            <div className="flex flex-col">
              <p>
                {maintenanceForwardingsDirectiveEntryKlasses[workflow.current_forwarding.directive_entry_type]?.label || '--'}
              </p>

              {workflow.current_forwarding.status && (
                <p className="text-xs italic">
                  {maintenanceForwardingStatus[workflow.current_forwarding.status]?.label || workflow.current_forwarding.status}
                </p>
              )}

            </div>
          ),
          process_id: (
            <div className="flex flex-col">
              <p>
                {workflow.id.split('-')[0].toUpperCase()}
              </p>

              <p className="text-xs italic text-white-400">
                {formatDateTime(new Date(workflow.created_at))}
              </p>
            </div>
          ),
          company: (
            <ImageWithDisplayName
              placeholderIcon={BriefcaseBusinessIcon}
              imageUrl={workflow.company?.general_information?.company_logo?.url}
              displayName={workflow.company?.general_information?.fantasy_name}
            />
          ),
          equipment: (
            <ImageWithDisplayName
              placeholderIcon={CarFrontIcon}
              imageUrl={workflow.equipment?.photos?.[0]?.url}
              displayName={workflow.equipment?.field_for_display_value}
            />
          ),
          actions: (
            <Link to={workflow.id}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Establishment::Maintenance::Workflows::Show"
              >
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        };
      });
    }
  }

}
